import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import '../../styles/login.css';
import { connect } from 'react-redux';
import axios from 'axios'



function Signup(props) {

  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState('');
  const navigate = useNavigate();


  const handleSubmit = (event) => {
    event.preventDefault()

    let user = {
      username: username,
      email: email,
      password: password
    }

    if (password.length < 8) {
      setErrors("Password must be at least 8 characters.")
    } else if (email.includes("@revenueads.com")) {
      axios.post(`${process.env.REACT_APP_API_URL || ''}/register`, { user })
        .then(response => {
          navigate('/login')
        })
        .catch(error => console.log('api errors:', error))
    } else {
      setErrors("Email not qualified for account")
    }
  };



  return (
    <div>
      <Container fluid className="form-container d-flex justify-content-center align-items-center">
        <Form className="login-form shadow p-3 bg-white rounded" onSubmit={handleSubmit}>
          <h2 className="mb-3">Register</h2>
          <Form.Group className="mb-3" controlId="formName">
            <Form.Label>Username</Form.Label>
            <Form.Control type="text" placeholder="Enter Username" onChange={e => { setUsername(e.target.value); setErrors('') }} value={username} name="username" />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formEmail">
            <Form.Label>Email address</Form.Label>
            <Form.Control type="email" placeholder="Enter Email" onChange={e => { setEmail(e.target.value); setErrors('') }} value={email} name="email" />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formPassword">
            <Form.Label>Password</Form.Label>
            <Form.Control type="password" placeholder="Password" onChange={e => { setPassword(e.target.value); setErrors('') }} value={password} name="password" />
          </Form.Group>
          {errors && (
            <div className="errors">
              <p className="text-danger">{errors}</p>
            </div>
          )}
          <Button className="formButton" type="submit">
            Register
          </Button>
        </Form>
      </Container>
    </div>
  );

}
export default connect()(Signup);